import { guidePathForSlug } from '../Guides/guidePaths.js';
export const articlePath = post => guidePathForSlug(post.slug) || `/pulse/${encodeURIComponent(post.slug)}`;
export const pulseMetadata = post => ({
  title: post.meta_title || post.title,
  description: String(post.meta_description || post.excerpt || '').substring(0, 210),
  canonical: `https://www.shuttleops.com${articlePath(post)}`,
  image: post.feature_image || 'https://www.shuttleops.com/assets/social-share-image.png',
});
